import { APIEvent } from "@solidjs/start/server";

import UFunction from "@repo/utils/UFunction";

import Experiment from "~/utils/Experiment";

// Commented out routes are only implemented in React app, until they're
// implemented in Solid, this should be omitted.
const usMigrationRoutes = {
  stable: [
    "/signup/info",
    "/onboarding/info",
    "/signup/identity-verification",
    "/onboarding/identity-verification",
    "/onboarding/post/identity-verification",
    "/signup/not-eligible",
    "/onboarding/not-eligible",
    "/signup/flagged",
    "/onboarding/flagged",
    "/signup/duplicate-account",
    // "/onboarding/duplicate-account",
    "/signup/credit-freeze",
    "/onboarding/credit-freeze",
    "/signup/manual-identity-verification/persona-upload",
    // "/onboarding/manual-review",
    "/signup/itin-submitted",
    "/onboarding/itin-submitted",
  ],
  creditAccountActivation: [
    "/dashboard/store/get-started",
    "/dashboard/credit-account/start",
    "/dashboard/store/select-plan",
    "/dashboard/credit-account/start/select-plan",
    "/dashboard/credit-account/start/:tier/repayment",
  ],
  creditAccountDetails: [
    "/dashboard/credit-account",
    "/dashboard/credit-account/**",
  ],
};

const patterns = UFunction.memo((key: keyof typeof usMigrationRoutes) =>
  usMigrationRoutes[key].map((route) => new URLPattern(route, "path://"))
);
export const shouldServeUsMigrationRoute = (path: string) =>
  (import.meta.env.APP_ENV === "development"
    ? Object.keys(usMigrationRoutes).map(patterns).flat()
    : [
        ...patterns("stable"),
        ...(Experiment.Cookie.get("solidCreditAccountActivation")
          ? patterns("creditAccountActivation")
          : []),
        ...(Experiment.Cookie.get("solidCreditAccountDetails")
          ? patterns("creditAccountDetails")
          : []),
      ]
  ).some((pattern) => pattern.test(`path://${path}`));

export function GET({}: APIEvent) {
  return Response.json({
    routes: usMigrationRoutes,
  });
}
